import { useContext, useState } from "react";
import { Button, IconGoogle } from "../../../../components/atoms";
import { InputGroup, SelectGroup } from "../../../../components/molecules";
import { AuthContext } from "../../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../../helpers";

export function FormPartner() {
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const { applicationData } = useContext(AuthContext);
  const [campoObrigatorioNome, setcampoObrigatorioNome] =
    useState<boolean>(false);
  const [campoObrigatorioTelefone, setcampoObrigatorioTelefone] =
    useState<boolean>(false);
  const [campoObrigatorioCNPJ, setcampoObrigatorioCNPJ] =
    useState<boolean>(false);
  const [campoObrigatorioCidade, setcampoObrigatorioCidade] =
    useState<boolean>(false);
  const [campoObrigatorioRazao, setcampoObrigatorioRazao] =
    useState<boolean>(false);
  const [campoObrigatorioEndereco, setcampoObrigatorioEndereco] =
    useState<boolean>(false);
  const [campoObrigatorioBairro, setcampoObrigatorioBairro] =
    useState<boolean>(false);
  const [campoObrigatorioNumero, setcampoObrigatorioNumero] =
    useState<boolean>(false);
  const [campoObrigatorioOperacao, setcampoObrigatorioOperacao] =
    useState<boolean>(false);

  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [cidade, setCidade] = useState("0");
  const [razao, setRazao] = useState("");
  const [endereco, setEndereco] = useState("");
  const [bairro, setBairro] = useState("");
  const [numero, setNumero] = useState("");
  const [operacao, setOperacao] = useState("0");
  const [email, setEmail] = useState("");
  const [complemento, setComplemento] = useState("");
  const [cep, setCep] = useState("");
  const [inscestadual, setInscestadual] = useState("");
  const [inscmunicipal, setInscmunicipal] = useState("");
  const [banco, setBanco] = useState("0");
  const [agencia, setAgencia] = useState("");
  const [conta, setConta] = useState("");
  const [limite, setLimite] = useState(0);
  const [comissao, setComissao] = useState(0);
  const [vendedor, setVendedor] = useState("0");
  const [fornecedor, setFornecedor] = useState("0");
  const [senha, setSenha] = useState("");
  const [obs, setObs] = useState("");

  const gravar = async () => {
    let useradd = applicationData.funcionario;
    const response = await api.post("/api/cliente/addjson", {
      nome,
      telefone,
      cnpj,
      cidade,
      razao,
      endereco,
      bairro,
      numero,
      operacao,
      email,
      complemento,
      cep,
      inscestadual,
      inscmunicipal,
      banco,
      agencia,
      conta,
      limite,
      comissao,
      vendedor,
      fornecedor,
      senha,
      obs,
      useradd,
    });
    if (response.status === 200) {
      setType("success");
      setTextAlert(response.statusText);
      setShow(true);
    }
  };

  return (
    <div>
      <h2>Incluir Parceiro</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Nome"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="nome"
            type="string"
            value={nome}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNome(true);
              else {
                setNome(e.target.value);
                setcampoObrigatorioNome(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="CNPJ"
            messageError={campoObrigatorioCNPJ ? "Campo obrigatório!" : ""}
            id="cnpj"
            type="string"
            value={cnpj}
            maxLength={14}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioCNPJ(true);
              else {
                setCnpj(e.target.value);
                setcampoObrigatorioCNPJ(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Telefone"
            messageError={campoObrigatorioTelefone ? "Campo obrigatório!" : ""}
            id="telefone"
            type="string"
            value={telefone}
            maxLength={14}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioTelefone(true);
              else {
                setTelefone(e.target.value);
                setcampoObrigatorioTelefone(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Razao"
            messageError={campoObrigatorioRazao ? "Campo obrigatório!" : ""}
            id="razao"
            type="string"
            value={razao}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioRazao(true);
              else {
                setRazao(e.target.value);
                setcampoObrigatorioRazao(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Email"
            id="email"
            type="string"
            value={email}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setEmail(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="% Comissao"
            id="comissao"
            type="number"
            value={comissao}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 100 &&
                Number(e.target.value) >= 0
              ) {
                setComissao(Number(e.target.value));
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Endereco"
            messageError={campoObrigatorioEndereco ? "Campo obrigatório!" : ""}
            id="endereco"
            type="string"
            value={endereco}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioEndereco(true);
              else {
                setEndereco(e.target.value);
                setcampoObrigatorioEndereco(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Complemento"
            id="complemento"
            type="string"
            value={complemento}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setComplemento(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Numero"
            messageError={campoObrigatorioNumero ? "Campo obrigatório!" : ""}
            id="numero"
            type="string"
            value={numero}
            maxLength={10}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNumero(true);
              else {
                setNumero(e.target.value);
                setcampoObrigatorioNumero(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Bairro"
            messageError={campoObrigatorioBairro ? "Campo obrigatório!" : ""}
            id="bairro"
            type="string"
            value={bairro}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioBairro(true);
              else {
                setBairro(e.target.value);
                setcampoObrigatorioBairro(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Cep"
            id="cep"
            type="string"
            value={cep}
            maxLength={8}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setCep(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={cidade}
            id="cidade"
            messageError={campoObrigatorioCidade ? "Campo obrigatório!" : ""}
            label="Cidade"
            options={applicationData.cidades.map((cidade: Cidade) => ({
              text: cidade.nome,
              value: cidade.codigo,
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) > 0
              ) {
                setCidade(e.target.value);
                setcampoObrigatorioCidade(false);
              }
              if (e.target.value === "") setcampoObrigatorioCidade(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={operacao}
            id="operacao"
            messageError={campoObrigatorioOperacao ? "Campo obrigatório!" : ""}
            label="Operacao"
            options={applicationData.operacoes.map((operacao: Operacao) => ({
              text: operacao.nome,
              value: operacao.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                setOperacao(e.target.value);
                setcampoObrigatorioOperacao(false);
              }
              if (e.target.value === "") setcampoObrigatorioOperacao(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Inscricao Estadual"
            id="inscestadual"
            type="string"
            value={inscestadual}
            maxLength={15}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setInscestadual(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={vendedor}
            id="vendedor"
            label="Vendedor"
            options={applicationData.gparceiros.map((gparceiro: GParceiro) => ({
              text: gparceiro.nome,
              value: gparceiro.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                setVendedor(e.target.value);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={fornecedor}
            id="fornecedor"
            label="Fornecedor"
            options={applicationData.gparceiros.map((gparceiro: GParceiro) => ({
              text: gparceiro.nome,
              value: gparceiro.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                setFornecedor(e.target.value);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Limite (R$)"
            id="limite"
            type="number"
            value={limite}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) > 0
              ) {
                setLimite(Number(e.target.value));
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Inscricao Municipal"
            id="inscmunicipal"
            type="string"
            value={inscmunicipal}
            maxLength={10}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setInscmunicipal(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={banco}
            id="banco"
            label="Banco"
            options={applicationData.bancos.map((banco: Banco) => ({
              text: banco.banco,
              value: banco.codigo,
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) >= 0
              ) {
                setBanco(e.target.value);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Agencia Bancaria"
            id="agencia"
            type="string"
            value={agencia}
            maxLength={15}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setAgencia(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Conta Corrente"
            id="conta"
            type="string"
            value={conta}
            maxLength={15}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setConta(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Senha"
            id="senha"
            type="string"
            value={senha}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setSenha(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-9">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Observacao"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="obs"
            type="string"
            value={obs}
            maxLength={250}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setObs(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar();
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  );
}
